var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoTwm = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 201.4,
    height: 47,
    viewBox: "0 0 201.4 47",
    style: {
      enableBackground: "new 0 0 201.4 47"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D82400;}\r\n\t.st1{fill:#F73603;}\r\n\t.st2{fill:#DD5298;}\r\n\t.st3{fill:#3E1EE6;}\r\n\t.st4{fill:#624BEE;}\r\n\t.st5{fill:#FF8F08;}\r\n\t.st6{fill:#FF6700;}\r\n\t.st7{fill:#024D59;}\r\n\t.st8{fill:#FFBA0D;}\r\n\t.st9{fill:#098979;}\r\n\t.st10{fill:#FFD60B;}\r\n\t.st11{fill:#22DDB9;}\r\n\t.st12{fill:#0EAA7D;}\r\n\t.st13{fill:#FF9B0B;}\r\n\t.st14{fill:#CE2874;}\r\n\t.st15{fill:#2D2D6C;}\r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.3,32.6l-15.8-9.1v18.2L39.3,32.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.7,32.6l15.8,9.1V23.5L7.7,32.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47,23.5l-3.1-11.8l-4.6,2.6L47,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M39.3,32.6l-4,11.2l8.6-8.6L39.3,32.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M43.9,35.2L47,23.5l-7.7,9.1L43.9,35.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M23.5,5.3L7.7,14.4l15.8,9.1V5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.3,32.6V14.4l-15.8,9.1L39.3,32.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M7.7,14.4v18.2l15.8-9.1L7.7,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M23.5,47l11.8-3.1l-11.8-2.1V47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M39.3,14.4l4.6-2.6l-8.6-8.6L39.3,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M39.3,14.4L23.5,5.3v18.2L39.3,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M3.1,11.7L0,23.5l7.7-9.1L3.1,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M23.5,41.7l-11.8,2.1L23.5,47V41.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M7.7,14.4l4-11.2l-8.6,8.6L7.7,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M23.5,0L11.8,3.1l11.8,2.1V0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,23.5l3.1,11.7l4.6-2.6L0,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M7.7,32.6l-4.6,2.6l8.6,8.6L7.7,32.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M35.3,3.1L23.5,0v5.3L35.3,3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M23.5,41.7l11.8,2.1l4-11.2L23.5,41.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M7.7,32.6l4,11.2l11.8-2.1L7.7,32.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M39.3,14.4l-4-11.2L23.5,5.3L39.3,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M39.3,14.4v18.2l7.7-9.1L39.3,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M23.5,5.3L11.8,3.1l-4,11.2L23.5,5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M7.7,32.6V14.4L0,23.5L7.7,32.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M164.2,7.2h-13v6.2h13V7.2z M153.8,9.6h7.7v1.5h-7.7V9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M167.2,13.7h2.7V5.9h2.8V3.3H149v2.6h18.3V13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M62.7,27.2h18.1c2.3,0,3.9-1.3,3.9-3.5v-7.1h-22V27.2z M65.6,19.4h16.2v3.5c0,1.2-0.6,1.5-1.7,1.5H65.6V19.4z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M80.1,7.8l1.9,3.3H65.3v-0.6c0-1.2,0.6-1.9,1.5-2.4l7-3.4L72.5,2l-7.2,3.6c-2.2,1.1-3.1,2.8-3.1,5V14h21.4 l0.8,1.4l2.6-1.3l-4.3-7.5L80.1,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M147.7,17.3h19.5v5.1c0,2.8-2,3.4-4.6,3.4v2.7h0.4c4.5,0,6.9-2,6.9-6.1v-5.1h3.3v-2.6h-25.6V17.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M133.8,11.4h10.7v-3h-10.7V2.9h-3.1v5.6h-10.5v3h10.3c-1,5.3-2.9,10.7-11.2,13.8l1.5,2.7 c7.9-3,10.4-7.7,11.5-12.3c1.8,4.8,5.4,9.9,11.4,12.3l1.6-2.8C138.2,21.9,135,16.2,133.8,11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M164.2,18.6h-13.3V25h13.3V18.6z M161.5,22.7h-8v-1.7h8V22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M189.5,11.4h10.7v-3h-10.7V2.9h-3.1v5.6H176v3h10.3c-1,5.3-2.9,10.7-11.2,13.8l1.5,2.7 c7.9-3,10.4-7.7,11.5-12.3c1.8,4.8,5.4,9.9,11.4,12.3l1.6-2.8C193.9,21.9,190.6,16.2,189.5,11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M92.7,18.5c0,3.9-0.6,6.2-3.5,7.5l1.6,2.2c3.9-1.5,4.5-5.3,4.5-10.1v-0.2h-2.7V18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M89.9,4.1l4,4.4l2-1.8l-4-4.3L89.9,4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M89.7,11l3.9,4.4l2-1.8l-4-4.3L89.7,11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M100.1,21.1h14.6v-5.2H97.2V18H112V19H97.8l-1.2,6.2l2.6,0.4l0.2-1.2H113c-0.4,0.9-1.8,1.4-5.7,1.5v2.4h0.3 c5.9,0,8.2-1.7,8.2-4.9v-1.3H99.9L100.1,21.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M102.3,5.3V3.3h2.7V2.3h2.1v1.1h2.8v1.9H102.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M107.1,14.7v-1.1h-1.9v1.1h-1.9v-3h5.7v3H107.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M108.7,8.9h-5.2v1.9h5.2V8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M108.7,6.1h-5.2v1.9h5.2V6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M100.3,12.7h-1.5v-0.1c0-0.3,0-0.7,0.3-1.1l3.6-4.3l-1.5-1.2l-1.4,1.6h-1V7.1c0-0.4,0.1-0.6,0.3-0.9l2-2.5 l-1.5-1.2l-2.4,2.8c-0.4,0.5-0.6,1-0.6,1.7v2.2h1.8l-1.1,1.3c-0.5,0.5-0.7,1.2-0.7,2.2v1.9h5.8V11h-2.1V12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M113.5,12.7H112v-0.1c0-0.3,0-0.7,0.3-1.1l3.6-4.3l-1.5-1.2L113,7.6h-1V7.1c0-0.4,0.1-0.6,0.3-0.9l2-2.5 l-1.5-1.2l-2.4,2.8c-0.4,0.5-0.6,1-0.6,1.7v2.2h1.8l-1.1,1.3c-0.5,0.5-0.7,1.2-0.7,2.2v1.9h5.8V11h-2.1V12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M146.8,33.6c-0.1,0.2-0.2,0.3-0.3,0.5c1.9,2.1,4,3.2,6.2,4.1c-0.3,0.3-0.7,0.8-0.9,1.2 c-2.1-1-4.1-2.2-6.1-4.3c-1.6,1.8-3.8,3.3-6,4.3c-0.2-0.4-0.6-0.8-0.9-1.2c2.7-1,5.3-2.9,6.8-5.2L146.8,33.6z M146.5,45h5.4v1.3 h-12.5V45h1.8v-5.3h1.3V45h2.5v-7.8h1.4v3.2h4.1v1.2h-4.1V45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M163.7,43.2c1.3,0.9,3.2,1.7,5,2c-0.3,0.3-0.7,0.9-0.9,1.2c-1.9-0.5-3.9-1.5-5.3-2.8v3h-1.3v-2.9 c-1.4,1.2-3.4,2.1-5.2,2.7c-0.2-0.4-0.6-0.9-0.9-1.2c1.8-0.4,3.7-1.1,5-2.1h-4.6v-1.1h5.7v-0.9h-4.4v-1h4.4v-0.9h-5.1v-1.1h3 c-0.1-0.4-0.4-0.9-0.6-1.3l0.4-0.1h-3.3v-1.1h2.2c-0.2-0.6-0.7-1.4-1.1-2l1.2-0.4c0.5,0.6,1,1.5,1.2,2.1l-0.8,0.3h1.6v-2.5h1.3v2.5 h1.5v-2.5h1.3v2.5h1.6l-0.6-0.2c0.4-0.6,0.8-1.5,1-2.2l1.4,0.4c-0.4,0.7-0.8,1.5-1.2,2h2.1v1.1h-2.8c-0.3,0.5-0.6,1-0.8,1.4h3.1 v1.1h-5.2v0.9h4.5v1h-4.5v0.9h5.8v1.1L163.7,43.2L163.7,43.2z M159.9,36.8c0.3,0.4,0.5,1,0.6,1.3l-0.4,0.1h3.1 c0.2-0.4,0.5-0.9,0.6-1.4H159.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M176.7,45.1c0,0.7-0.1,1.1-0.5,1.3c-0.4,0.2-1,0.3-2,0.3c0-0.3-0.2-1-0.4-1.3c0.6,0,1.2,0,1.4,0 c0.2,0,0.3-0.1,0.3-0.3v-3.3h-2c-0.1,1.7-0.4,3.6-1.1,4.9c-0.2-0.2-0.8-0.5-1.1-0.6c1-2,1-5,1-7.1v-5.3h4.4L176.7,45.1L176.7,45.1z  M175.4,40.4v-2.2h-1.9v0.6c0,0.5,0,1,0,1.6L175.4,40.4L175.4,40.4z M173.5,37h1.9v-2.1h-1.9V37z M184.6,38.9c-0.4,2-1,3.6-1.9,4.9 c0.7,0.7,1.5,1.4,2.3,1.8c-0.3,0.3-0.7,0.7-0.9,1.1c-0.8-0.5-1.6-1.1-2.2-1.8c-0.6,0.7-1.3,1.3-2.1,1.7c-0.2-0.3-0.5-0.8-0.8-1v1 h-1.3v-13h6.4v2.8c0,0.6-0.1,1-0.6,1.2c-0.5,0.2-1.3,0.2-2.4,0.2c-0.1-0.4-0.3-0.8-0.4-1.2c0.8,0,1.6,0,1.8,0c0.2,0,0.3,0,0.3-0.2 v-1.5h-3.8v3.7h4.5l0.2,0L184.6,38.9z M179.1,45.6c0.8-0.4,1.5-1,2.1-1.7c-0.8-1.1-1.4-2.4-1.8-3.9h-0.3V45.6z M180.5,39.9 c0.3,1,0.8,2,1.4,2.8c0.5-0.8,0.9-1.8,1.2-2.8H180.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M200.7,35c-0.5,1.3-1.2,2.4-2.2,3.2c0.9,0.5,1.8,0.8,2.9,1c-0.3,0.3-0.6,0.7-0.8,1.1 c-1.1-0.3-2.2-0.7-3.1-1.3c-1,0.7-2.2,1.1-3.5,1.5c-0.1-0.2-0.2-0.5-0.4-0.7c-0.2,0.9-0.5,1.8-0.8,2.4l-0.9-0.5 c0.2-0.6,0.5-1.4,0.6-2.2h-1.1V45c0,0.7-0.1,1-0.5,1.2c-0.4,0.2-1,0.3-1.9,0.3c0-0.4-0.2-0.9-0.4-1.3c0.6,0,1.2,0,1.4,0 c0.2,0,0.2,0,0.2-0.2v-3.9c-0.5,1.3-1.2,2.5-2,3.2c-0.1-0.4-0.5-1-0.7-1.3c0.9-0.8,1.7-2.2,2.3-3.5h-2.1v-1.2h2.6 c-0.4-0.6-1.1-1.2-1.7-1.7l1-0.6c0.3,0.2,0.6,0.5,0.9,0.7c0.5-0.5,1-1.1,1.4-1.7h-4v-1.2h4.9l0.2,0l0.9,0.5 c-0.6,1.1-1.6,2.3-2.6,3.1c0.2,0.2,0.3,0.3,0.4,0.5l-0.5,0.3h1.8l0.2-0.1l0.8,0.3c-0.1,0.3-0.1,0.5-0.2,0.8c1-0.2,1.9-0.6,2.8-1.1 c-0.6-0.5-1.1-1-1.5-1.6c-0.3,0.3-0.6,0.6-0.9,0.9c-0.2-0.2-0.8-0.6-1.1-0.8c1.2-0.8,2.2-2.2,2.8-3.6l1.2,0.4 c-0.2,0.4-0.4,0.8-0.6,1.2h3.2l0.2,0L200.7,35z M200.6,41.3c0,0,0,0.4,0,0.5c-0.3,2.7-0.5,3.9-1,4.3c-0.3,0.3-0.6,0.4-1,0.5 c-0.3,0-1,0-1.6,0c0-0.4-0.2-0.9-0.4-1.3c0.6,0.1,1.1,0.1,1.4,0.1c0.2,0,0.4,0,0.5-0.2c0.3-0.2,0.5-1,0.7-2.8h-2.2 c-0.5,1.8-1.5,3.3-3.9,4.2c-0.1-0.3-0.5-0.8-0.8-1c1.9-0.7,2.8-1.8,3.3-3.1h-2.1v-1.1h2.3c0.1-0.5,0.1-0.9,0.2-1.4h1.3 c0,0.5-0.1,0.9-0.2,1.4H200.6z M195.9,35.8c0.4,0.7,1,1.3,1.7,1.8c0.6-0.5,1.1-1.1,1.5-1.8H195.9z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoTwm);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/logo_twm.2399119b341085369a7b78707d7cc90f.svg";